<div class="space-y-3">
  <!-- Tanlangan o'qlar -->
  @for (axis of axes(); track axis.attributeId) {
    <div
      class="rounded-lg border border-emerald-200 dark:border-emerald-800/50 bg-emerald-50/60 dark:bg-emerald-900/10 p-3 space-y-2"
    >
      <div class="flex items-center justify-between">
        <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">{{ axis.name }}</span>
        <div class="flex items-center gap-1">
          <button
            type="button"
            (click)="axis.showNewValue = !axis.showNewValue; axis.newValue = ''"
            class="flex items-center gap-1 text-xs px-2 py-1 rounded-md text-emerald-700 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/30 transition-colors"
          >
            <i class="pi pi-plus text-xs"></i>
            {{ 'PRODUCTS.VARIANT.NEW_VALUE' | translate }}
          </button>
          <button
            type="button"
            (click)="removeAxis(axis.attributeId)"
            class="text-gray-400 hover:text-red-500 transition-colors p-1"
            [title]="'COMMON.DELETE' | translate"
          >
            <i class="pi pi-times text-xs"></i>
          </button>
        </div>
      </div>
      <p-multiSelect
        [options]="axis.values"
        [(ngModel)]="axis.selected"
        optionLabel="value"
        display="chip"
        [placeholder]="('PRODUCTS.VARIANT.SELECT' | translate) + ' ' + axis.name"
        appendTo="body"
        styleClass="w-full"
        (onChange)="recompute()"
      />
      @if (axis.showNewValue) {
        <div class="flex gap-2 pt-1">
          <input
            pInputText
            [(ngModel)]="axis.newValue"
            [placeholder]="'PRODUCTS.VARIANT.NEW_VALUE_PLACEHOLDER' | translate"
            (keyup.enter)="addValueToAxis(axis)"
            class="flex-1 text-sm"
          />
          <p-button
            [label]="'COMMON.CANCEL' | translate"
            severity="secondary"
            [outlined]="true"
            size="small"
            (onClick)="axis.showNewValue = false; axis.newValue = ''"
          />
          <p-button
            [label]="'COMMON.CREATE' | translate"
            severity="success"
            size="small"
            [disabled]="!axis.newValue?.trim()"
            (onClick)="addValueToAxis(axis)"
          />
        </div>
      }
    </div>
  }

  <!-- O'q qo'shish / yangi tur -->
  <div class="flex flex-wrap items-center gap-2">
    @if (availableAttributes().length > 0) {
      <p-select
        [options]="availableAttributes()"
        optionLabel="name"
        optionValue="id"
        [(ngModel)]="newAxisAttrId"
        [placeholder]="'PRODUCTS.VARIANT.ADD_TYPE' | translate"
        appendTo="body"
        styleClass="w-56"
        (onChange)="addAxis()"
      />
    }
    <p-button
      [label]="'PRODUCTS.VARIANT.NEW_TYPE' | translate"
      icon="pi pi-sparkles"
      severity="secondary"
      [text]="true"
      size="small"
      (onClick)="showNewAttr = !showNewAttr"
    />
  </div>

  <!-- Inline yangi tur yaratish -->
  @if (showNewAttr) {
    <div
      class="rounded-lg border border-dashed border-gray-300 dark:border-gray-700 p-3 space-y-2 bg-gray-50/50 dark:bg-gray-800/30"
    >
      <input
        pInputText
        [(ngModel)]="newAttrName"
        [placeholder]="'PRODUCTS.VARIANT.TYPE_NAME' | translate"
        class="w-full text-sm"
      />
      <input
        pInputText
        [(ngModel)]="newAttrValuesText"
        [placeholder]="'PRODUCTS.VARIANT.TYPE_VALUES' | translate"
        (keyup.enter)="createAttributeInline()"
        class="w-full text-sm"
      />
      <div class="flex gap-2 justify-end">
        <p-button
          [label]="'COMMON.CANCEL' | translate"
          severity="secondary"
          [outlined]="true"
          size="small"
          (onClick)="showNewAttr = false; newAttrName = ''; newAttrValuesText = ''"
        />
        <p-button
          [label]="'PRODUCTS.VARIANT.CREATE' | translate"
          severity="success"
          size="small"
          [loading]="savingAttr()"
          [disabled]="!newAttrName.trim() || !newAttrValuesText.trim()"
          (onClick)="createAttributeInline()"
        />
      </div>
    </div>
  }

  <!-- Kombinatsiyalar jadvali -->
  @if (combos().length > 0) {
    <div class="overflow-x-auto rounded-lg border border-gray-100 dark:border-gray-800 mt-1">
      <table class="w-full text-sm table-fixed">
        <thead>
          <tr class="bg-gray-50 dark:bg-gray-800/50 border-b border-gray-100 dark:border-gray-800">
            <th class="px-3 py-2 text-left text-xs font-semibold text-gray-500 dark:text-gray-400">
              {{ 'PRODUCTS.VARIANT.COL_VARIANT' | translate }}
            </th>
            @if (showQuantity) {
              <th
                class="px-3 py-2 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 w-24"
              >
                {{ 'PRODUCTS.VARIANT.COL_QTY' | translate }}
              </th>
            } @else {
              <th
                class="px-3 py-2 text-right text-xs font-semibold text-gray-500 dark:text-gray-400 w-20"
              >
                {{ 'PRODUCTS.DETAIL.IN_STOCK' | translate }}
              </th>
            }
            <th
              class="px-3 py-2 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 w-36"
            >
              {{ 'PRODUCTS.VARIANT.COL_PURCHASE_PRICE' | translate }}
            </th>
            <th
              class="px-3 py-2 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 w-36"
            >
              {{ 'PRODUCTS.VARIANT.COL_PRICE' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of combos(); track row.key) {
            <tr class="border-b border-gray-50 dark:border-gray-800/40 last:border-0">
              <td class="px-3 py-1.5 font-medium text-gray-900 dark:text-gray-100 break-words">
                {{ row.label }}
                @if (row.variantId) {
                  <p-tag
                    [value]="'VARIANTS_MGR.EXISTING_TAG' | translate"
                    severity="secondary"
                    styleClass="ml-1"
                  />
                } @else if (row.isDefaultTarget) {
                  <p-tag
                    [value]="'VARIANTS_MGR.DEFAULT_TARGET_TAG' | translate"
                    severity="info"
                    styleClass="ml-1"
                  />
                }
              </td>
              @if (showQuantity) {
                <td class="px-3 py-1.5 align-middle">
                  <p-inputnumber
                    [(ngModel)]="row.quantity"
                    (ngModelChange)="emit()"
                    [min]="0"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="4"
                    [useGrouping]="false"
                    styleClass="w-full"
                    inputStyleClass="w-full text-center"
                  />
                </td>
              } @else {
                <td
                  class="px-3 py-1.5 text-right"
                  [class.text-blue-600]="row.isDefaultTarget"
                  [class.dark:text-blue-400]="row.isDefaultTarget"
                  [class.font-semibold]="row.isDefaultTarget"
                  [class.text-gray-500]="!row.isDefaultTarget"
                  [class.dark:text-gray-400]="!row.isDefaultTarget"
                  [pTooltip]="
                    row.isDefaultTarget ? ('VARIANTS_MGR.DEFAULT_TARGET_HINT' | translate) : ''
                  "
                >
                  {{ row.currentStock ?? '—' }}
                </td>
              }
              <td class="px-3 py-1.5 align-middle">
                <p-inputnumber
                  [(ngModel)]="row.purchasePrice"
                  (ngModelChange)="emit()"
                  [min]="0"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="currencySvc.priceInputDecimals(purchaseCurrency)"
                  mode="decimal"
                  [useGrouping]="true"
                  [placeholder]="'VARIANTS_MGR.INHERIT' | translate"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                />
              </td>
              <td class="px-3 py-1.5 align-middle">
                <p-inputnumber
                  [(ngModel)]="row.price"
                  (ngModelChange)="emit()"
                  [min]="0"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="currencySvc.priceInputDecimals(sellCurrency)"
                  mode="decimal"
                  [useGrouping]="true"
                  [placeholder]="'VARIANTS_MGR.INHERIT' | translate"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                />
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <p class="text-xs text-gray-400 text-center py-3">
      {{ 'PRODUCTS.VARIANT.PICK_VALUES' | translate }}
    </p>
  }
</div>
